import { useState } from "react";

/**
 * Hook para manejar formularios
 *
 * @param {object} initialState - Estado inicial del formulario
 * @returns {array} [values, handleInputChange, reset, setFormValue]
 */
export const useForm = (initialState = {}) => {
  const [values, setValues] = useState(initialState); // Estado del formulario

  /**
   * Resetea el formulario
   *
   * @param {object} newSate - Nuevo estado del formulario
   * @returns {void}
   */
  const reset = (newSate = initialState) => {
    setValues(newSate);
  };

  /**
   * Maneja el cambio de los inputs del formulario
   *
   * @param {object} event - Evento del input
   * @returns {void}
   */
  const handleInputChange = ({ target }) => {
    setValues({
      ...values,
      [target.name]: target.value,
    });
  };

  /**
   * Establece el valor del formulario
   *
   * @param {object} form - Nuevo estado del formulario
   * @returns {void}
   */
  const setFormValue = (form) => {
    setValues(form);
  };

  return [values, handleInputChange, reset, setFormValue];
};
